<script setup>

// import { getCheckInfoAPI, createOrderAPI } from '@/apis/checkout'
import { useUserStore } from '@/stores/userStore'
import { ElMessage } from 'element-plus'
import {  setUserAPI,} from '@/apis/user'
import { createOrderAPI } from '@/apis/order'
import { useRouter } from 'vue-router'
import { throttle } from "@/utils/throttle"; // 引入节流
import { onMounted, ref, reactive } from 'vue'
import { useCartStore } from '@/stores/cartStore'

import { goUp,goRate,exchangeRate } from '@/utils/index'
import addressDIV from '@/components/checkout/address.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const userStore = useUserStore()
const cartStore = useCartStore()
const router = useRouter()


// const pay_type = ref(1)



const lijitotal = ref(0)//应付金额
const productTotalPrice=ref(0);//商品总价
const sku = reactive({
    data: {}
})
const freightFee = ref(0);
// 获取结算信息
const checkInfo = ref({}) // 订单对象
const curAddress = ref({}) // 默认地址
const getCheckInfo = async () => {
    checkInfo.value.goods = []
    const orderData = localStorage.getItem('order')
    if (orderData) {
        const item = JSON.parse(orderData);
        console.log('刷新后的数据', item)
        
        const isDisclaimer = item.some(obj => 
            obj.list.some(items => items.from?.trim())
        );
        console.log('isDisclaimer',isDisclaimer)
        if(isDisclaimer){
            dialogVisible.value=true
        }
        checkInfo.value.goods = item
        // if (item[0]?.sku) {
        //     sku.data = item[0].sku
        //     console.log('sku.data', item[0].sku)
        // }
        // console.log('sku.data', sku.data)
        if (item[0].freightFee) {
            freightFee.value = item[0].freightFee
        }
        console.log('循环列表的值', checkInfo.value.goods);
        cartStore.isPlaceAnOrder = checkInfo.value.goods
        console.log(checkInfo.value.goods.type)
        lijitotal.value = 0;
        console.log('liji', checkInfo.value.goods)
        checkInfo.value.goods.forEach(user => {
            // if (user.type == 1) {
            user.list.forEach(items => {
                if (items.selected) {
                    console.log('商品的价格--',items.quantity,goRate(items.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate))
                    // 累加每个商品的total_price
                    lijitotal.value += items.quantity * goRate(items.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate);
                    
                
                }
            })
            // }
        })
        //商品总价
        productTotalPrice.value=lijitotal.value
       
        if (freightFee.value != 0) {
            lijitotal.value = parseFloat(lijitotal.value) + parseFloat(goRate(freightFee.value,userStore.exchangeRate.symbol, userStore.exchangeRate.rate))
            console.log('总价',lijitotal.value)
        }

    } else {
        
        
        //从购物车过来的数据
        console.log('从购物车过来的数据', cartStore.checkoutList)
        let data = [];
        cartStore.checkoutList.forEach(user => {
            if (user.selected == true) {//代表这条数据全部都选中
               
                let item = {
                    avatar:user.avatar,
                    shop_user: user.shop_user,
                    shop_user_id: user.shop_user_id,
                    list: user.list.filter(item => item.selected == true)
                }

                data.push(item)
            } else {

                let itemList = []
                user.list.forEach(item => {
                    if (item.selected) {
                        itemList.push(item)
                    }
                });
                console.log(itemList.length)
                if (itemList.length > 0) {
                    let item = {
                        avatar:user.avatar,
                        shop_user: user.shop_user,
                        shop_user_id: user.shop_user_id,
                        list: itemList
                    }
                    data.push(item)
                }
            }
        })
        console.log('列表数据',data)
        
        const isDisclaimer = data.some(obj => 
        obj.list.some(item => item.source?.trim())
        );
        console.log('isDisclaimer',isDisclaimer)
        if(isDisclaimer){
            dialogVisible.value=true
        }
        const allFromEmpty = data.every(item => item.list.every(subItem => subItem.source == ''));
        console.log('allFromEmpty',allFromEmpty)//false
        // if () {
        //     freightFee.value = item[0].freightFee
        // }
        if(allFromEmpty==false){
            // if (cartStore.checkoutList[0].freightFee) {
            //     freightFee.value = cartStore.checkoutList[0].freightFee
            //     data[0].freightFee=freightFee.value
            // }
            freightFee.value =  data.reduce((total, currentItem) => {
                // 计算当前项的freight_fee总和
                const currentFreightFeeTotal = currentItem.list.reduce((sum, subItem) => sum + subItem.freight_fee, 0);
                // 将当前项的freight_fee总和添加到累计总和中
                return total + currentFreightFeeTotal;
            }, 0);
            console.log('yunfei---',freightFee.value)
            data[0].freightFee=freightFee.value
        }
        
        console.log('最后页面显示值,', data)
        localStorage.setItem('order', JSON.stringify(data))
        checkInfo.value.goods = data
        lijitotal.value = 0;
        console.log('liji', checkInfo.value.goods)
       
        data.forEach(user => {
            // if (user.type == 1) {
            user.list.forEach(items => {
                if (items.selected) {
                    console.log('商品的价格--',goRate(items.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate))
                    // 累加每个商品的total_price
                    lijitotal.value += items.quantity * goRate(items.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate);
                }
            })
            // }
        })
        //商品总价
        productTotalPrice.value=lijitotal.value
        if (freightFee.value != 0) {
            lijitotal.value = parseFloat(lijitotal.value) + parseFloat(goRate(freightFee.value,userStore.exchangeRate.symbol, userStore.exchangeRate.rate))
            console.log('总价',lijitotal.value)
        }
    }
}




const isMobile = ref(false);
onMounted(() => {
    getCheckInfo()
    userStore.getUser()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
   

}
)






const userDialog = ref(false)
const userformRef = ref()
const param = reactive({
    form: {
        telegram: userStore.userInfo.telegram,
        watchApp: userStore.userInfo.watchApp,

    },
    payData:{

    }
})
const userClose = () => {
    userStore.getUser()
    userDialog.value = false
    param.form.watchApp == ''
    param.form.telegram == ''
}
/**
 * 用户配置信息
 */
const userSubmit = () => {
    userformRef.value.validate(async (valid) => {
        if (valid) {

            if (param.form.watchApp == '' && param.form.telegram == '') {
                ElMessage({
                    message: t('cart16'),
                    type: 'warning',
                })
            } else {
                const res = await setUserAPI(param.form)
                if (res.code == 0) {
                    ElMessage({ type: 'success', message: t('cart17') })
                    userClose()
                } else {
                    ElMessage({ type: 'error', message: res.message })
                }
            }



        }
    })
}

/**
 * 获取地址
 */
const getAddress=(data)=>{
    console.log('地址',data)
    curAddress.value=JSON.parse(JSON.stringify(data))
}

// 创建订单
const createOrder = async () => {
            const zhi = userStore.CurrencyAll.find(rate => rate.symbol === "$");
            console.log(zhi)
            // if (userStore.userInfo.watchApp == '' && userStore.userInfo.telegram == '') {
            //     userDialog.value = true
            //     return;
            // } else {
               console.log(curAddress.value) 
                if (Object.keys(curAddress.value).length===0) {
                    ElMessage({
                        message: t('cart18'),
                        type: 'warning',
                    })
                    return;
                }
               
                console.log(checkInfo.value.goods)
                let shoplist = []
                checkInfo.value.goods.map(user => {
                    let shopitem = {
                        shop_user_id: null,
                        data: []
                    }
                    if (user.shop_user_id) {
                        shopitem.shop_user_id = user.shop_user_id//卖家用户id
                    } else {
                        shopitem.shop_user_id = 0
                    }
                    user.list.map(item => {
                        let list = {}
                        // list.shop_user_id = item.belong_user_id//卖家用户id
                        list.product_id = item.id//产品id
                        // list.total_amount = item.price * item.num
                        // list.pay_amount = item.price * item.num
                        list.buy_num = item.quantity//购买数量
                        list.from=item.source//数据来源：taobao  1688   微店
                        console.log('skuid',item.sku_info)
                        list.sku_info={
                            sku_id:item?.sku_id || null,//skuid
                            properties_name:item?.sku_name || '',//sku规格
                        }
                        // list.sku_info = {
                        //     sku_id: sku_info || null,
                        //     properties_name: sku.data.properties_name || '',
                        // }


                        shopitem.data.push(list)
                    })
                    shoplist.push(shopitem)
                })
                console.log('list数据',shoplist)
                // let myObject = {}
                // let thirdData = localStorage.getItem('thirdData')
                // //将JSON字符串转换回对象
                // if (thirdData) {
                //     myObject = JSON.parse(thirdData);
                // }
                let data = {
                    list: shoplist,
                    // exchange_rate: userStore.exchangeRate.rate,//汇率
                    // currency: userStore.exchangeRate.currency,//货币类型
                    address_id: curAddress.value.id,//地址id
                    shipping_name: curAddress.value.surname + curAddress.value.name,//收货人
                    shipping_phone: curAddress.value.area_code + curAddress.value.mobile,//手机号
                    // total_price: goUp(lijitotal.value * zhi.rate),//总价
                    // from: myObject.from || '',
                }
                console.log(data)
                const res = await createOrderAPI(data)
                if (res.code == 0) {
                    ElMessage({ type: 'success', message: t('cart19') })
                    // 更新购物车
                    console.log('订单号---',res.data.order_no_list)
                    cartStore.order_no_list=res.data.order_no_list
                    cartStore.updateNewList()
                    // router.push({ path: '/Payment'});
                    router.replace({ path: '/Payment'})
                } else {
                    ElMessage({ type: 'error', message: res.message })
                }
             
       
// }
}
const handleSubmit = throttle(createOrder, 5000);
const dialogVisible = ref(false);
const confirm = () => {
    dialogVisible.value = false;
};

</script>

<template>
    <div class="checkout">
    <div class="xtx-pay-checkout-page" v-if="isMobile==false">
        <div class="container">
            <div class="wrapper">
               <!-- 收货地址 -->
                <addressDIV @getAddress="getAddress"></addressDIV>
                <!-- 商品信息 -->
                 <div class="ProductInformation">
                    <div class="box-title">{{ $t('cart27') }}</div>
                    <div class="box-body">
                        <div class="goods">
                            <div class="pc">
                                <div class="thead-top" >
                                    <div class="name">{{ $t('cart27') }}</div>
                                    <div class="price">{{ $t('cart28') }}</div>
                                    <div class="number">{{ $t('cart29') }}</div>
                                    <div class="total">{{ $t('cart30') }}</div>
                                </div>
                            </div>
                            <div class="content">
                                <div v-for="(list, index) in checkInfo.goods" :key="index">
                                    <div class="username">
                                        <img :src="list.avatar" alt="" style="width: 20px;height: 20px;">
                                        {{ list.shop_user }}
                                    </div>
                                    <div class="thead" v-for="i in list.list" :key="i.id">
                                        <div class="name">
                                            <div class="goods">
                                                <RouterLink class="image" to="/"><img :src="i.cover_url" alt="" />
                                                </RouterLink>
                                                <div class="goodstitle">
                                                    <p class="ellipsis-2">
                                                        {{ i.name }}
                                                    </p>
                                                    <p class="Attribute">{{ i.sku_name }}</p>
                                                    <p class="Attribute" style=" color: #FFFFFF; /* 白色文字 */
    " v-if="i.needIntlPostage"><span style="background-color: #FF0000; padding: 0 10px;border-radius: 12px;">{{ $t('setup670') }}</span></p>
                                                        <!--v-if="isMobile == true" <p v-else class=" ellipsis">{{ sku.data.properties_name }}</p> -->
                                                    
                                                    <!-- <p class="phone red"><span
                                                            v-if="userStore.exchangeRate.symbol == '￥'">￥{{
                                                                i.price }}</span><span v-else>{{ exchangeRate(
                                                                i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                                        }}</span> x {{ i.num }}</p>
                                                    <p class="phone">{{ $t('cart31') }}:<span
                                                            v-if="userStore.exchangeRate.symbol =='￥'">¥{{ goUp(i.price *
                                                                i.num) }}</span><span v-else>{{userStore.exchangeRate.symbol}}{{goUp((goRate(i.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate)* i.num)) }}</span>
                                                    </p> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="price priceFamit">
                                            <p>
                                                <span v-if="userStore.exchangeRate.symbol == '￥'">￥{{ i.price }}</span>
                                                <span v-else> {{
                                                    exchangeRate(
                                                        i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                                            </p>
                                        </div>
                                        <div class="number">
                                            <el-input-number v-model="i.quantity" :disabled="true" style="width: 130px;"/>
                                        </div>
                                        <div class="total">
                                            <p class="f16 red"><span v-if="userStore.exchangeRate.symbol == '￥'">￥{{
                                                goUp(i.price * i.quantity) }}</span>
                                                <span v-else>{{userStore.exchangeRate.symbol}}{{goUp((goRate(i.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate)* i.quantity))  }}</span></p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
               <!-- <PaymentMethods></PaymentMethods> -->
            </div>
        </div>
        <div class="DetailedAccount">
            <div class="AccountSubmit">
                <div>{{$t('setup485')}}：
                    <span  v-if="userStore.exchangeRate.symbol == '￥'">￥{{goUp(productTotalPrice) }}</span>
                    <span  v-else>{{userStore.exchangeRate.symbol}}{{goUp(productTotalPrice) }}</span>
                </div>
                <div v-if="freightFee!=0">{{$t('setup474')}}：{{ exchangeRate(freightFee, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)}}</div>
                <div style="display: flex;align-items: center;">
                    <div>{{$t('setup486')}}：<span class="price"  v-if="userStore.exchangeRate.symbol == '￥'">￥{{goUp(lijitotal) }}</span>

                                <span class="price"  v-else>{{userStore.exchangeRate.symbol}}{{goUp(lijitotal) }}</span></div>
                    <div class="submitbut" @click="handleSubmit">{{ $t('cart34') }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="phoneCheckout" v-else>
        <div class="address">
            <addressDIV @getAddress="getAddress"></addressDIV>
        </div>
        <!-- 商品信息 -->
        <div class="ProductInformation">
            <div class="content">
                <div v-for="(list, index) in checkInfo.goods" :key="index">
                    <div class="username">
                        <img :src="list.avatar" alt="" style="width: 18px;height: 18px;">
                        {{ list.shop_user }}
                    </div>
                    <div class="thead" v-for="i in list.list" :key="i.id">
                        <div class="name">
                            <div class="goods">
                                <RouterLink class="image" to="/"><img :src="i.cover_url" alt="" style="width: 82px;height: 82px;"/>
                                </RouterLink>
                                <div class="goodstitle">
                                    <div>
                                        <p class="ellipsis">
                                        {{ i.name }}
                                        </p>
                                        <p class="Attribute">{{ sku.data.properties_name }}</p>
                                    </div>
                                   
                                    <div class="price">
                                        <p class="pricecolor" style="font-size: 18px;">
                                            <span v-if="userStore.exchangeRate.symbol == '￥'">￥{{ i.price }}</span>
                                            <span v-else> {{
                                                exchangeRate(
                                                    i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                                        </p>
                                        <div class="number">
                                            <el-input-number v-model="i.quantity" :disabled="true" style="width: 110px;" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hrdiv"></div>
                        <!-- <div class="total">
                            <p class="f16 red"><span v-if="userStore.exchangeRate.symbol == '￥'">￥{{
                                goUp(i.price * i.num) }}</span>
                                <span v-else>{{userStore.exchangeRate.symbol}}{{goUp((goRate(i.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate)* i.num))  }}</span></p>
                        </div> -->
                    </div>
                    
                </div>
                <div class="TotalPrice">
                    <div>{{$t('setup485')}}：
                    <span class="pricecolor" style="font-size: 16px;" v-if="userStore.exchangeRate.symbol == '￥'">￥{{goUp(productTotalPrice) }}</span>
                    <span  class="pricecolor" style="font-size: 16px;" v-else>{{userStore.exchangeRate.symbol}}{{goUp(productTotalPrice) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="Freight" v-if="freightFee!=0">
            <div>{{$t('setup474')}}：</div><div class="pricecolor">{{ exchangeRate(freightFee, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)}}</div>
        </div>
        <div class="Totalbottom">
            <div class="payableprice">
                <div class="Actualpayment">{{$t('setup486')}}：
                    <span class="price" style="font-size: 18px;"  v-if="userStore.exchangeRate.symbol == '￥'">￥{{goUp(lijitotal) }}</span>
                    <span class="price" style="font-size: 18px;" v-else>{{userStore.exchangeRate.symbol}}{{goUp(lijitotal) }}</span>
                </div>
                <div class="Payable">
                    {{$t('setup457')}}：
                        <span  v-if="userStore.exchangeRate.symbol == '￥'">￥{{goUp(productTotalPrice) }}</span>
                        <span  v-else>{{userStore.exchangeRate.symbol}}{{goUp(productTotalPrice) }}</span>
                </div>
            </div>
           
            <div class="submitbut" @click="handleSubmit">{{ $t('cart34') }}</div>
        </div>
    </div>
    <!-- <el-drawer v-model="drawer" show-close :with-header="false" direction="btt" :before-close="drawerClose" size="70%">
        <div class="bankList">
            <div class="CardList">
                <div v-for="(item, i) in bankList" :key="i" @click="setCard(item)"
                    :class="checkCradItem.id == item.id ? 'checkItemCard' : 'itemCard'">
                    <div>{{ item.bank_name }}</div>
                    <div v-if="checkCradItem.id == item.id">
                        <div style="padding-top: 10px;" class="title" v-if="item.telegram">
                            <div class="unselectable">
                                <a :href="`${item.telegram}`" target="_blank" rel="nofollow"
                                    class="button" v-if="item.telegram" style="padding-right: 10px;">
                                    <img src="../../assets/images/telegram.png"
                                        style="width: 26px;height: 26px;border-radius: 50%;" alt="" srcset="">
                                </a>{{ item.telegram }}<el-button type="warning" size="small" @click="handleCopy(item.telegram)" style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button></div>
                        </div>
                        <div style="padding-top: 10px;" class="title" v-if="item.whats_app">
                            <div class="unselectable"><a :href="`${item.whats_app}`" target="_blank" rel="nofollow"
                                    class="button" style="padding-right: 10px;" v-if="item.whats_app">
                                    <img src="../../assets/images/watch.png"
                                        style="width: 26px;height: 26px;border-radius: 50%;    " alt="" srcset="">
                                </a>{{ item.whats_app }} <el-button type="warning" size="small" @click="handleCopy(item.whats_app)" style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button></div>
                        </div>
                        <div class="copy" v-if="item.paypal_address" style="padding-top: 10px;">
                            <el-input v-model="item.paypal_address" disabled style="width: 216px;" />
                            <el-button type="warning" @click="handleCopy(item.paypal_address)"
                                style="margin-left: 10px;" size="small" plain>{{ $t('setup60') }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawerbut">
            <el-button type="warning" class="btn" :disabled="Object.keys(checkCradItem).length ==0" @click="drawer=false">
                            {{ $t("home4") }}
            </el-button>
        </div>
    </el-drawer>-->
    <el-dialog v-model="userDialog" :title="t('cart38')" width="350" :before-close="userClose">
        <el-form ref="userformRef" :model="param.form" size="large" label-position="top" label-width="60px">
            <el-form-item prop="telegram" label="telegram" class="form-item">
                <el-input v-model="param.form.telegram" placeholder="telegram">
                </el-input>
            </el-form-item>
            <el-form-item prop="watchApp" label="watchApp" class="form-item">
                <el-input v-model="param.form.watchApp" placeholder="watchApp">
                </el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="userClose">Cancel</el-button>
                <el-button type="primary" @click="userSubmit">
                    {{ $t('cart39') }}
                </el-button>
            </div>
        </template>
    </el-dialog> 
   
    <!-- <usdPayment ref="paychild" v-if="usdPayModel" :payData="param.payData"  :usdPayModel="usdPayModel"></usdPayment> -->
</div>
<el-dialog
    :title="t('setup465')"
    v-model="dialogVisible"
    width="30%"
    v-if="isMobile==false"
    :before-close="handleClose"
  >
    <div>
        <ol>
        <li>{{ $t('setup467') }}</li>
        <li>{{ $t('setup468') }}</li>
        <li>{{ $t('setup469') }}</li>
        <li>{{ $t('setup470') }}</li>
        <li>{{ $t('setup471') }}</li>
      </ol>
    </div>
    <span class="dialog-footer" style="display: flex;justify-content: flex-end;">
      <!-- <el-checkbox v-model="noPrompt">不再提示</el-checkbox> -->
     
      <el-button type="primary" @click="confirm">{{ $t('cart8') }}</el-button>
    </span>
  </el-dialog>
  <el-dialog
    :title="t('setup465')"
    v-model="dialogVisible"
    width="90%"
    v-else
    :before-close="handleClose"
  >
    <div>
        <ol>
        <li>{{ $t('setup467') }}</li>
        <li>{{ $t('setup468') }}</li>
        <li>{{ $t('setup469') }}</li>
        <li>{{ $t('setup470') }}</li>
        <li>{{ $t('setup471') }}</li>
      </ol>
    </div>
    <span class="dialog-footer" style="display: flex;justify-content: flex-end;">
      <!-- <el-checkbox v-model="noPrompt">不再提示</el-checkbox> -->
     
      <el-button type="primary" @click="confirm">{{ $t('cart8') }}</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss">
.checkout{
    background-color: #eef0f1;
}
.drawerbut{
    width: 90%;
    height: 50px;
    position: fixed;
    padding: 6px 0px;
    text-align: end;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
}
.bankList {
            padding-top: 20px;
            margin-bottom: 50px;
            .CardList {
                // display: grid;
                // grid-template-columns: repeat(auto-fit, minmax(150px, 0fr));
                // grid-auto-rows: 50px;
                // grid-gap: 10px;

                .itemCard {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    border: 1px solid #e4e7ed;
                    border-radius: 5px;
                    padding: 10px;

                    &:hover {
                        background: #79bbff3b;
                        border-radius: 5px;
                        border: 1px solid #79bbff;
                    }
                }

                .checkItemCard {
                    padding: 10px;
                    display: flex;
                    align-items: flex-start;
                    background: rgba(121, 187, 255, 0.231372549);
                    border-radius: 5px;
                    border: 1px solid #79bbff;
                    flex-direction: column;
                }
            }

            .title {
                padding: 5px 0;
            }
        }
.xtx-pay-checkout-page {
    margin-top: 20px;
    background-color: #eef0f1;
    .DetailedAccount{
        margin-top: 32px;
        height: 100px;
        background: #FFFFFF;
        box-shadow: 0px -5px 8px 0px #F3F6F8; 
        .AccountSubmit{
            height: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            margin:0 auto;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #0F0F0F;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            .submitbut{
                margin-left: 46px;
                padding: 12px 76px;
                height: 46px;
                background: #FC3938;
                border-radius: 23px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                text-transform: uppercase;
            }
            .price{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
font-weight: bold;
font-size: 24px;
color: #FC3938;
line-height: 19px;
text-align: left;
font-style: normal;
            }
        }
    }
    .wrapper {
        margin: 20px 0 0 0;
        // background: #fff;
        // padding: 0 20px;
        width: 1200px;
        // 
       .ProductInformation{
       
        padding: 20px;
        margin-top: 20px;
        background: #FFFFFF;
        border-radius: 8px;
            .box-title {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #11192D;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                padding: 10px 0 20px 0;
            }

            .box-body {
                padding: 0px 0;
                .goods {
                    width: 100%;
                    border-collapse: collapse;
                    border-spacing: 0;

                    .thead-top {
                        display: flex;
                        align-items: center;
                        padding: 18px 20px;
                        background: #FFF1EB;
                        border-radius: 8px;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #000000;
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                        .check {
                            width: 120px;
                        }

                       
                    }
                    .content {
                        .username {
                            margin-top: 20px;
                            padding: 16px 20px;
                            // border-bottom: 1px solid #aaaaaa;
                            background: #F5F6F8;
                            border-radius: 8px 8px 0px 0px;
                            .user {
                                padding-left: 20px;
                            }
                        }
                        .thead {
                        display: flex;
                        align-items: center;
                        padding: 18px 20px;
                        background: #FFFFFF;
                        // border-radius: 0px 0px 8px 8px;
                        border-radius: 0; /* 默认不显示圆角 */
                        border: 1px solid #E5E8EC;
                        border-top: none; /* 去掉上边框 */
                        .check {
                            width: 120px;
                        }
                    }
                    /* 仅最后一个 .thead 显示圆角 */
                    .thead:last-child {
                        border-radius: 0 0 8px 8px;
                    }
                    }
                    .name {
                            width: 554px;

                            .goods {
                                display: flex;
                                flex-direction: row;

                                .image {
                                    width: 82px;
                                    height: 82px;
                                    border-radius: 8px;
                                }

                                img {
                                    width: 82px;
                                    height: 82px;
                                    border-radius: 8px;
                                }
                                .goodstitle{
                                    
                                    padding-left: 15px;
                                    display: flex;
                                    flex-direction: column;
                                    height: 82px;
                                    justify-content: space-around;
                                    .ellipsis-2{
                                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                                        font-weight: bold;
                                        font-size: 16px;
                                        color: #11192D;
                                        line-height: 25px;
                                        text-align: left;
                                        font-style: normal;
                                        width: 410px;
                                    }
                                    .Attribute{
                                        font-family: MicrosoftYaHei;
                                        font-size: 14px;
                                        color: #666666;
                                        line-height: 19px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                }
                                // >div {
                                //     width: 170px;
                                //     font-size: 16px;
                                //     padding-left: 10px;

                                //     .attr {
                                //         font-size: 14px;
                                //         color: #999;
                                //     }
                                // }
                            }
                        }
                        .priceFamit{
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #666666;
                            line-height: 19px;
                            text-align: left;
                            font-style: normal;
                        }
                        .price {
                            width: 220px;
                            display: flex;
                            justify-content: center;
                        }
                        .number{
                            width: 220px;
                            display: flex;
                            justify-content: center;
                        }

                        .total {
                            width: 180px;
                            display: flex;
                            justify-content: flex-end;
                        }

                        .operate {
                            width: 140px;
                        }
                   

                }
            }
        }
        // .bankList {
        //     padding-top: 20px;

        //     .CardList {
        //         // display: grid;
        //         // grid-template-columns: repeat(auto-fit, minmax(150px, 0fr));
        //         // grid-auto-rows: 50px;
        //         // grid-gap: 10px;

        //         .itemCard {
        //             display: flex;
        //             justify-content: flex-start;
        //             align-items: center;
        //             border: 1px solid #e4e7ed;
        //             border-radius: 5px;
        //             padding: 10px;

        //             &:hover {
        //                 background: #79bbff3b;
        //                 border-radius: 5px;
        //                 border: 1px solid #79bbff;
        //             }
        //         }

        //         .checkItemCard {
        //             padding: 10px;
        //             display: flex;
        //             align-items: flex-start;
        //             background: rgba(121, 187, 255, 0.231372549);
        //             border-radius: 5px;
        //             border: 1px solid #79bbff;
        //             flex-direction: column;
        //         }
        //     }

        //     .title {
        //         padding: 5px 0;
        //     }
        // }
    }
}

.address {
    border: 1px solid #f5f5f5;
    display: flex;
    align-items: center;

   

    .action {
        width: 420px;
        text-align: center;

        .btn {
            width: 140px;
            height: 46px;
            line-height: 44px;
            font-size: 14px;

            &:first-child {
                margin-right: 10px;
            }
        }
    }
}



.my-btn {
    width: 228px;
    height: 50px;
    border: 1px solid #e4e4e4;
    text-align: center;
    line-height: 48px;
    margin-right: 25px;
    color: #666666;
    display: inline-block;

    &.active,
    &:hover {
        border-color: $xtxColor;
    }
}

.total {
    dl {
        display: flex;
        justify-content: flex-end;
        line-height: 50px;

        dt {
            i {
                display: inline-block;
                width: 2em;
            }
        }

        dd {
            width: 240px;
            text-align: right;
            padding-right: 70px;

            &.price {
                font-size: 20px;
                color: $priceColor;
            }
        }
    }
}

.submit {
    text-align: right;
    padding: 60px;
    border-top: 1px solid #f5f5f5;
}



.dialogcontent {
    .title {
        font-size: 16px;
        padding: 8px 0;
    }

    .copy {
        padding: 20px 0;
        display: flex;
    }


    .CardList {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        grid-auto-rows: 50px;
        grid-gap: 10px;

        .itemCard {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #e4e7ed;
            border-radius: 5px;

            &:hover {
                background: #79bbff3b;
                border-radius: 5px;
                border: 1px solid #79bbff;
            }
        }

        .checkItemCard {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #79bbff3b;
            border-radius: 5px;
            border: 1px solid #79bbff;
        }
    }

}


/* 响应式设计 */
@media (max-width: 768px) {
    .checkout{
        height: 100%;
    }
    .phoneCheckout{
        height: 100%;
        margin-top: 88px;
        background: #f7f7f7;
        padding: 15px 15px 0 15px;
        .address{
            margin-bottom: 15px;
            >div{
                width: 100%;
            }
        }
        .ProductInformation{
            background: #FFFFFF;
            box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
            border-radius: 4px;
            padding-bottom: 15px;
            margin-bottom: 15px;
            .content{
                .username{
                    padding: 15px 15px 7px 15px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #222222;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
                .thead{
                    .name{
                       .goods{
                        padding: 15px;
                        display: flex;
                        .image{
                            width: 82px;
                            height: 82px;
                        }
                        .goodstitle{
                            padding-left: 11px;
                            width: calc(100% - 82px);
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .ellipsis{
                                width: 179px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #222222;
                                line-height: 20px;
                                text-align: left;
                                font-style: normal;
                            }
                            .Attribute{
                                padding-top: 6px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 12px;
                                color: #888888;
                                line-height: 17px;
                                text-align: left;
                                font-style: normal;
                            }
                            .price{
                                display: flex;
                                align-items: flex-end;
                                justify-content: space-between;
                            }
                        }
                       } 
                    }
                    .hrdiv{
                        width: 100%;
                        height: 1px;
                        background: #EEEEEE;
                    }
                }
                .TotalPrice{
                    padding: 15px 15px 0 15px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #222222;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                    text-align: end;
                }
            }
        }
        .Freight{
            margin-bottom: 15px;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
            border-radius: 8px;
            padding: 20px 15px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #222222;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .Totalbottom{
            height: 54px;
            background: #FFFFFF;
            padding: 4px 5px;
            z-index: 999;
            position: fixed;
            left: 0;
            bottom: 0;
            background: #fff;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .submitbut{
                margin-left: 5px;
                background: #FC3938;
                border-radius: 20px;
                padding: 10px 34px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;
            }
            .payableprice{
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                .Actualpayment{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #FF4F00;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    white-space: nowrap;
                }
                .Payable{
                    padding-top: 4px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 10px;
                    color: #999999;
                    line-height: 10px;
                    text-align: left;
                    font-style: normal;
                }
            }
            
        }
        .pricecolor{
            color: #FF4F00;
        }
    }

}

</style>